import { useState, useEffect } from "react";

import sanityClient from "../api/sanityClient"; // Adjust the path as needed
import fetchContactUs from "../api/fetchContactUs"; // Adjust the path as needed

import imageUrlBuilder from "@sanity/image-url";
import SplashScreen from "../Components/SplashScreen/SplashScreen";
import BaseLayout from "../Components/BaseLayout/BaseLayout";
import Footer from "../Components/Footer/Footer";
import Menu from "../Components/Menu/Menu";

import "../styles/pages/contactPage.scss";
import { PortableText } from "@portabletext/react";

// Set up image builder
const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source).url();
}

export const ContactPage = () => {
  const [showLoading, setShowLoading] = useState(true);
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchContactUs();
      console.log(data);

      setContactData(data);
    };

    loadData();
  }, []);

  // Handle loading state
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoading(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Menu />
      {showLoading ? <SplashScreen /> : ""}
      <div className="contact-container fade-in">
        {contactData ? (
          <>
            <BaseLayout title={contactData.title} subTitle="Sponsors">
              <div className="contact-content">
                <div className={"contact-text block-content max-text-width"}>
                  <PortableText value={contactData.content} />
                </div>
                {/* Page Image */}
                {console.log(contactData.image)}
                {contactData.image && (
                  <img
                    src={urlFor(contactData.image) + "?w=1200&h=900"}
                    alt={contactData.title}
                    className="contact-image"
                  />
                )}
              </div>
            </BaseLayout>
            <Footer />
          </>
        ) : (
          <BaseLayout title={"Loading..."} subTitle="Our contact" />
        )}
      </div>
    </>
  );
};

export default ContactPage;
